// Gestion cross-browser du Wake Lock (empêche la mise en veille de l'écran)
// Utilisation : import { setupWakeLock } from './utils/wakeLock.js'; puis setupWakeLock();

export function setupWakeLock() {
    if ('wakeLock' in navigator) {
        let wakeLock = null;

        async function requestWakeLock() {
            try {
                wakeLock = await navigator.wakeLock.request('screen');
                console.log('Wake Lock actif');
                wakeLock.addEventListener('release', () => {
                    console.log('Wake Lock libéré');
                });
            } catch (err) {
                console.error(`Erreur lors de la demande de Wake Lock: ${err.name}, ${err.message}`);
            }
        }

        document.addEventListener('visibilitychange', async () => {
            if (document.visibilityState === 'visible' && wakeLock === null) {
                await requestWakeLock();
            }
        });

        requestWakeLock();
    } else {
        console.warn("L'API Wake Lock n'est pas supportée par ce navigateur.");
    }
}
